import Subscription from "@/js/shared/classes/Subscription/Subscription";

export default class SportsSubscription extends Subscription {
    constructor(data) {
        super(data)
    }
    
    getSubscriptionForm = () => {
        const {
            subscriptionStartDate,
            subscriptionEndDate,
            isDemo,
            systemFee,
            isManualBilling,
            profilePrice,
            billingCycle,
            doNotRenew,
            isFree,
            productSubscriptionId,
            profileCount,
            packageTier,
            manualEstimatedTotal,
            profileAddOnCount,
            freeProfilesCount,
            updateFutureSubscriptions,
            snoozeInvoice,
            snoozeOverage
        } = this.data;

        return {
            subscriptionStartDate,
            subscriptionEndDate,
            billingCycle,
            profileCount,
            profilePrice,
            packageTier,
            systemFee,
            isManualBilling,
            isDemo,
            productSubscriptionId,
            isFree,
            doNotRenew,
            isPrePaid: true,
            isClinical: false,
            manualEstimatedTotal,
            profileAddOnCount,
            freeProfilesCount,
            updateFutureSubscriptions,
            snoozeInvoice,
            snoozeOverage
        }
    }

    static getNewSportsSubscriptionForm = () => {
        return {
            subscriptionStartDate: null,
            subscriptionEndDate: null,
            billingCycle: null,
            profileCount: null,
            profilePrice: null,
            packageTier: null,
            systemFee: null,
            isManualBilling: false,
            isDemo: false,
            productSubscriptionId: null,
            isFree: false,
            doNotRenew: false,
            isPrePaid: true,
            isClinical: false,
            manualEstimatedTotal: null,
            profileAddOnCount: null,
            freeProfilesCount: null,
            updateFutureSubscriptions: false,
            snoozeInvoice: false,
            snoozeOverage: false
        }
    }
}